import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import {
    SignedInGuard
} from '../guards';

import {
    PageAuctionSearchComponent,
    PageManageAuctionFiltersComponent
} from './pages'

const routes: Routes = [
    { path: 'manage-filters', component: PageManageAuctionFiltersComponent, data: { title: 'Manage Filters', pageRef: 'A02' } },
    { path: '', component: PageAuctionSearchComponent, data: { title: 'Auctions', pageRef: 'A00' } },
    { path: ':auctionId', component: PageAuctionSearchComponent, data: { title: 'Auction Lots', pageRef: 'A01' } },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AuctionRoutingModule { }
